import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';


export function* getModuleDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('modules?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('modules'));
        }
        yield put({
            type: actions.MODULE_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.MODULE_DETAILS_FAILURE });
        return error;
    }
}


export function* getComponentDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('component-types?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('component-types'));
        }
        yield put({
            type: actions.COMPONENT_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.COMPONENT_DETAILS_FAILURE });
        return error;
    }
}

export function* getRoleDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('clientRole?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('clientRole'));
        }
        yield put({
            type: actions.ROLE_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
        return true;
    } catch (error) {
        yield put({ type: actions.ROLE_DETAILS_FAILURE });
        return error;
    }
}

export function* getFeatureDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('features?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('features'));
        }
        yield put({
            type: actions.FEATURE_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.FEATURE_DETAILS_FAILURE });
        return error;
    }
}

export function* getFeatureComponentDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('featureComponents?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('featureComponents'));
        }
        yield put({
            type: actions.FEATURE_COMPONENT_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.FEATURE_COMPONENT_DETAILS_FAILURE });
        return error;
    }
}



export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_SECURITY_DETAILS_SUCCESS,
    });
}


export default function* younoteAdminSecuritySetupSaga() {
    yield all([
        takeEvery(actions.MODULE_DETAILS_START, getModuleDetails),
        takeEvery(actions.FEATURE_DETAILS_START, getFeatureDetails),
        takeEvery(actions.FEATURE_COMPONENT_DETAILS_START, getFeatureComponentDetails),
        takeEvery(actions.COMPONENT_DETAILS_START, getComponentDetails),
        takeEvery(actions.ROLE_DETAILS_START, getRoleDetails),
        takeEvery(actions.CLEAR_SECURITY_DETAILS_START, getClearDetails)
    ]);
}